import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class SalesOpportunitiesDetails<T extends EMode = EMode.entity> {
  /** Alias: v_Code */
  id?: number;
  /** Alias: vB_Amount */
  amount?: any;
  /** Alias: vB_Percent */
  percent?: any;
  /** Alias: vB_Rated */
  rated?: any;

  __typename?: string;
}

const fields: FieldDefinitions<SalesOpportunitiesDetails> = {
  id: {
    alias: 'v_Code',
  },
  amount: {
    alias: 'vB_Amount',
  },
  percent: {
    alias: 'vB_Percent',
  },
  rated: {
    alias: 'vB_Rated',
  },
  __typename: {
    alias: '__typename',
  },
};

export const salesOpportunitiesDetailsEntityDefinition: EntitiyDefinition<SalesOpportunitiesDetails> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'VerkaufschancenDetails',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
